export const brand = {
  name: "瓜田爆料",
  fullName: "瓜田爆料 · 爆料鉴定所",
  slogan: "不站队，只梳理证据",
  tagline: "真假鉴定 · 实锤分析 · 证据链整理 · 辟谣汇总",
  description:
    "瓜田爆料专注爆料可信度鉴定，提供真假鉴定、实锤分析、证据链整理和辟谣汇总。针对热门瓜进行可信度评估，帮你分辨真伪，看清事件全貌。",
  email: "verify@guatian-baoliao.com",
  tipEmail: "tips@guatian-baoliao.com",
  cooperateEmail: "coop@guatian-baoliao.com",
  keywords: ["瓜田爆料", "真假鉴定", "实锤分析", "证据链", "辟谣汇总", "可信度评估", "实锤整理"],
  updateNote: "每周一、周四更新鉴定结果",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "爆料库", to: "/gossip" },
  { label: "辟谣汇总", to: "/debunk" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
  { label: "联系我们", to: "/contact" },
];

export const footerLinks = {
  browse: [
    { label: "全部爆料", to: "/gossip" },
    { label: "实锤确认", to: "/gossip?verdict=实锤" },
    { label: "存疑待核", to: "/gossip?verdict=存疑" },
    { label: "辟谣汇总", to: "/debunk" },
  ],
  about: [
    { label: "关于我们", to: "/about" },
    { label: "鉴定方法", to: "/about#method" },
    { label: "内容原则", to: "/about#principle" },
    { label: "常见问题", to: "/faq" },
  ],
  service: [
    { label: "投稿爆料", to: "/contact" },
    { label: "纠错反馈", to: "/contact" },
    { label: "合作洽谈", to: "/contact" },
    { label: "订阅播报", to: "/contact" },
  ],
};

export const categories = [
  { key: "恋情绯闻", name: "恋情绯闻", desc: "同款、行程、互动细节的交叉核对", count: 1284, icon: "ri-heart-3-line" },
  { key: "事业动向", name: "事业动向", desc: "合约、资源、行程变动的信号梳理", count: 962, icon: "ri-bar-chart-box-line" },
  { key: "学历履历", name: "学历履历", desc: "公开履历与可查证记录的比对", count: 431, icon: "ri-file-list-3-line" },
  { key: "口碑争议", name: "口碑争议", desc: "现场反馈、从业者说法与官方回应", count: 738, icon: "ri-chat-voice-line" },
  { key: "团队纠纷", name: "团队纠纷", desc: "片酬、分成、合约类争议的证据整理", count: 356, icon: "ri-scales-3-line" },
  { key: "官方辟谣", name: "官方辟谣", desc: "已被官方或当事人明确澄清的传闻", count: 615, icon: "ri-shield-check-line" },
];

export const partnerCount = 42;

export const stats = [
  { value: "5,286", label: "已鉴定条目", note: "累计完成真假鉴定的爆料理" },
  { value: "1,964", label: "证据链条目", note: "被结构化归档的可查证线索" },
  { value: "615", label: "已澄清传闻", note: "有官方或当事人明确回应" },
  { value: "7", label: "评估维度", note: "统一的爆料可信度评估框架" },
];

export const testimonials = [
  {
    name: "林可",
    role: "娱乐内容编辑",
    text: "写稿前会先来瓜田查一遍，证据链按来源等级排好，直接用得很省心，比在群聊里翻截图靠谱太多。",
  },
  {
    name: "周叙",
    role: "追剧观众",
    text: "最有用的是结论标签，一眼知道这条是实锤还是待定，不会跟着评论区情绪跑。",
  },
  {
    name: "陈默",
    role: "自媒体运营",
    text: "辟谣汇总那一块几乎是我每周必看的，很多已经被澄清的传闻还在传，这里能查到官方出处。",
  },
  {
    name: "苏晚",
    role: "粉丝站管理员",
    text: "被误伤的时候会把鉴定页面甩过去，评估维度和来源都写得很清楚，沟通成本低了不少。",
  },
];

export const credibilityRules = [
  { level: "85 - 100", verdict: "实锤", desc: "存在可独立核验的硬证据，且多方来源相互印证，无有力反证。" },
  { level: "60 - 84", verdict: "存疑", desc: "证据倾向成立，但关键环节仍依赖单一来源，尚不足以完全确认。" },
  { level: "30 - 59", verdict: "待定", desc: "线索存在但零散，来源等级偏低，交叉印证不足，需继续观察。" },
  { level: "0 - 29", verdict: "辟谣", desc: "出现明确官方回应或硬反证，传闻不成立或被误读。" },
];